import { P2GBox, P2GFade, P2GImage, P2GText } from '@parcel2go/core-ui';
import { LinkApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import useOnLoad from '~/routes/use-on-load';
import { useState } from 'react';

interface props {
  item: SmartSendItemApiModel;
  wrapper: (content: React.ReactNode) => React.ReactElement;
}

const PrintInStoreQrCodesAutoLoad = ({ item, wrapper }: props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { getPrintInStoreLinks } = useSmartSendApi();
  const [links, setLinks] = useState<LinkApiModel[] | null>(null);

  useOnLoad(() => {
    const fetchLinks = async () => {
      const res = await getPrintInStoreLinks(
        item.Service.Provider,
        item.Service.AccountId,
        item.BookingDetails.OrderLineId
      );

      if (res.success && res.result?.Links?.length) {
        setLinks(res.result.Links.filter((x) => x.Type === 'PRINT-IN-STORE_BARCODE'));
      }
    };
    fetchLinks();
  });

  if (!links?.length) {
    return null;
  }

  return wrapper(
    <P2GFade in>
      <P2GBox display="flex" gap={2} flexWrap="wrap" justifyItems="center" justifyContent="center">
        {links.map((link) => (
          <P2GBox alignItems="center" display="flex" flexDirection="column" key={link.Href} gap={1}>
            <P2GImage
              src={link.Href}
              alt={t('PRINT_IN_STORE_BARCODE_ALT_TEXT', { defaultValue: 'Print In-Store Barcode' })}
              style={{ width: '256px', margin: '5px', border: '1px solid #ccc' }}
            />
            {links.length > 1 && (
              <P2GText component="p" variant="subtitle2">
                {link.Label}
              </P2GText>
            )}
          </P2GBox>
        ))}
      </P2GBox>
    </P2GFade>
  );
};

export default PrintInStoreQrCodesAutoLoad;
